import { Utils } from "../../shared/constants/utilities.constants";
import { IFeatureDiameterDto } from "./interfaces/feature-diameter-dto.interface";

export const diameterFilterExist = (diameterFilter: IFeatureDiameterDto): boolean => {
    return !Utils.isNullOrUndefined(diameterFilter) && 
           !Utils.isNullOrUndefined(diameterFilter.dn) &&  
           !Utils.isNullOrUndefined(diameterFilter.mm) && 
           !Utils.isNullOrUndefined(diameterFilter.nps);
}